import { render, staticRenderFns } from "./LastDayPayReport.vue?vue&type=template&id=bd5ef530&"
import script from "./LastDayPayReport.vue?vue&type=script&setup=true&lang=js&"
export * from "./LastDayPayReport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports